import { equals, equals2, go, last } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
export const removeCuttingLinePathCommand = (self, command) => {
  self._checkIsPathEditing();
  const outer_cutting_line_clip_path_el =
    self._getOuterCuttingLineClipPathElThrowable();
  const outer_cutting_line_display_path_el =
    self._getOuterCuttingLineDisplayPathElThrowable();
  if (self._path_editor_list.length <= 3) {
    throw new Error(`더 이상 패스를 삭제할 수 없습니다.`);
  }
  const idx = self._path_editor_list.findIndex(({ model }) =>
    equals(model)(command)
  );
  if (idx < 0) {
    throw new Error(`선택된 패스가 없습니다.`);
  }
  if (equals2(idx + 1)(self._path_editor_list.length)) {
    throw new Error(`마지막 패스는 삭제할 수 없습니다.`);
  }
  if (equals2(idx)(0)) {
    if (self._path_editor_list[0] == null) {
      throw new Error(`path command 를 찾을 수 없습니다.`);
    }
    const active_path_editor = self._path_editor_list[0];
    if (self._path_editor_list[1] == null) {
      throw new Error(`path command 를 찾을 수 없습니다.`);
    }
    const next_path_editor = self._path_editor_list[1];
    if (self._path_editor_list[2] == null) {
      throw new Error(`path command 를 찾을 수 없습니다.`);
    }
    const next_next_path_editor = self._path_editor_list[2];
    const point = next_path_editor.model.getTargetPoint();
    active_path_editor.model.moveTargetPoint(point);
    next_next_path_editor.model.setPrevCommand(null);
    next_path_editor.model.setPrevCommand(null);
    next_next_path_editor.model.setPrevCommand(active_path_editor.model);
    next_path_editor.view.remove();
    self._path_editor_list = [
      self._path_editor_list[0],
      ...self._path_editor_list.slice(2),
    ];
    const d = go(
      self._path_editor_list,
      last,
      (a) => a?.model,
      (m) => m?.toString()
    );
    if (d != null) {
      self._outer_cutting_line_path_data = d;
      outer_cutting_line_clip_path_el.setAttributeNS(null, "d", d);
      outer_cutting_line_display_path_el.setAttributeNS(null, "d", d);
      outer_cutting_line_clip_path_el.dispatchEvent(
        new CustomEvent("@mp/sticker-editor/outer-cutting-line-changed", {
          bubbles: true,
          cancelable: true,
          composed: false,
          detail: {
            path_data: d,
          },
        })
      );
    }
    return;
  }
  if (self._path_editor_list[idx] == null) {
    throw new Error(`path command 를 찾을 수 없습니다.`);
  }
  const active_path_editor = self._path_editor_list[idx];
  if (self._path_editor_list[idx + 1] == null) {
    throw new Error(`path command 를 찾을 수 없습니다.`);
  }
  const next_path_editor = self._path_editor_list[idx + 1];
  if (self._path_editor_list[idx - 1] == null) {
    throw new Error(`path command 를 찾을 수 없습니다.`);
  }
  const prev_path_editor = self._path_editor_list[idx - 1];
  active_path_editor.model.setPrevCommand(null);
  next_path_editor.model.setPrevCommand(null);
  next_path_editor.model.setPrevCommand(prev_path_editor.model);
  active_path_editor.view.remove();
  self._path_editor_list = [
    ...self._path_editor_list.slice(0, idx),
    ...self._path_editor_list.slice(idx + 1),
  ];
  const d = go(
    self._path_editor_list,
    last,
    (a) => a?.model,
    (m) => m?.toString()
  );
  if (d != null) {
    self._outer_cutting_line_path_data = d;
    outer_cutting_line_clip_path_el.setAttributeNS(null, "d", d);
    outer_cutting_line_display_path_el.setAttributeNS(null, "d", d);
    outer_cutting_line_clip_path_el.dispatchEvent(
      new CustomEvent("@mp/sticker-editor/outer-cutting-line-changed", {
        bubbles: true,
        cancelable: true,
        composed: false,
        detail: {
          path_data: d,
        },
      })
    );
  }
};
